import { Input_Base } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Base.ts';
import { InputEditor } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/type.ts';
import { LowStockVariantId } from '@services/MarppleShop/features/ProductMeta';
import { FormDropdown } from '@services/MarppleShop/shared/components/cells/FormDropDown/FormDropdown.ts';
import {
  formKeyMap,
  ValidateField,
} from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/shared.ts';
import { FORM_DROPDOWN_CONSTANT } from '@services/MarppleShop/shared/components/cells/FormDropDown/type.ts';
import { LOW_STOCK_VARIANT_LABEL } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/constants.ts';
import { entries, fx } from '@fxts/core';
import { ValueOf } from '../../../../../../../shared/type/util.type.ts';
import klass from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input.module.scss';
import { html } from 'rune-ts';

interface InputStockThresholdSelector extends InputEditor {
  value: LowStockVariantId | null;
  setField: (keyName: ValueOf<typeof formKeyMap>, value: LowStockVariantId | null) => void;
}

export class Input_StockThresholdSelector extends Input_Base<InputStockThresholdSelector> {
  private dropdown_items = [
    { key: '', name: '표시하지 않음', value: null },
    ...fx(entries(LOW_STOCK_VARIANT_LABEL)).map(([lowStockVariantId, label]) => ({
      key: lowStockVariantId,
      name: label,
      value: lowStockVariantId,
    })),
  ];

  private dropDown = new FormDropdown<LowStockVariantId | null>(
    {
      name: this.data.name,
      status: FORM_DROPDOWN_CONSTANT.ACTIVE,
      items: this.dropdown_items,
      selected_item: this.dropdown_items.find(({ value }) => value === this.data.value),
    },
    {
      klass: klass.dropdown,
      size: 'small',
      onSelectHook: (item) => {
        this.data.setField(formKeyMap.low_stock_threshold, item.value ?? null);
      },
    },
  );

  protected inputTemplate() {
    return html` <div class="${klass.dropdown_wrap}">${this.dropDown}</div>`;
  }

  public getName(): ValidateField {
    return this.data.name;
  }

  public override setError() {
    return void 0;
  }

  public getValue() {
    return void 0;
  }
}
